var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5312L17.4188 8.84996L20 6.625V11.5312Z",
    fill: "#EE1D23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.58438 8.84996L0 11.5343V6.625L2.58438 8.84996Z",
    fill: "#EE1D23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 13.9687V16.4375C20 17.0344 19.5156 17.5188 18.9188 17.5188H1.08125C0.484336 17.5188 0 17.0344 0 16.4375V13.9687L3.86559 9.95621L8.28125 13.7593C8.74063 14.1531 9.34996 14.3719 10 14.3719C10.65 14.3719 11.2625 14.1531 11.7219 13.7593L16.1343 9.95621L20 13.9687Z",
    fill: "#EE1D23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.55933V4.64058L10.5687 12.7656C10.2655 13.0281 9.73434 13.0281 9.43121 12.7656L0 4.64058V3.55933C0 2.96249 0.484297 2.4812 1.08125 2.4812H18.9188C19.5156 2.4812 20 2.96249 20 3.55933Z",
    fill: "#EE1D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRed);
export default __webpack_public_path__ + "static/media/email-red.739b3e803c0dffddf022ce15ce7d4642.svg";
export { ForwardRef as ReactComponent };